/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilityRangeResponseSchema } from './availabilityRangeResponseSchema';

export const workloadSchemeWithRangesSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  default: z.boolean(),
  description: z.string().nullish(),
  id: z.int(),
  instanceId: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  locationIds: z.array(z.int()),
  memberCount: z.int(),
  name: z.string(),
  organizationId: z.string(),
  get ranges() {
    return z.array(availabilityRangeResponseSchema);
  },
  sourceId: z.string().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
